import store from "../../store/store";
import {
    HAS_ONBOARDING,
    HOLDING_STEP,
    RESET_ONBOARDING,
    SET_ALLOW_ACTIONS_NEXT,
    SET_ALLOW_ACTIONS_PREVIOUS,
    SET_COMPLETED_ALL,
    SET_FINISHED,
    SET_ONBOARDING_PER_PAGE,
    SET_SKIP,
    SET_STEPS,
} from "../../store/modules/vueOnboardingModule";
import Vue from "vue";

class OnboardingService {

    isActivating() {
        return this.hasOnboarding() && !this.isCompletedAll() && !this.isHolding() && !this.isSkip();
    }

    hasOnboarding() {
        return store.state.vueOnboarding.hasOnboarding;
    }

    isCompletedAll() {
        return store.state.vueOnboarding.isCompletedAll;
    }
    
    isSkip() {
        return store.state.vueOnboarding.isSkip;
    }

    isHolding() {
        return store.state.vueOnboarding.isHolding;
    }

    start(step = null) {

        if(!this.hasOnboarding()) {
            console.log("[start] This account haven't onboarding");
            return;
        }

        if(step !== null) {
            Vue.prototype.$tours.onboarding.start(step);
        }
        else {
            Vue.prototype.$tours.onboarding.start();
        }
    }

    restart(customRestart = { fromStep: -1 }) {

        // Only account has onboarding state or not skip or not completed all can be restart
        if(!this.hasOnboarding() || this.isSkip() || this.isCompletedAll() || this.isHolding()) {
            console.log("[restart] This account haven't onboarding");
            return;
        }

        setTimeout(() => {
            this.reset({ fromStep: customRestart.fromStep });
            this.start();
        }, 0);
    }

    reset(customOptions = { fromStep: -1 }) {      
        Vue.prototype.$tours.onboarding.currentStep = customOptions.fromStep;
    }

    resetOnboarding() {
        store.dispatch(RESET_ONBOARDING);
    }

    next() {

        if(!this.hasOnboarding()) {
            console.log("[next] This account haven't onboarding");
            return;
        }

        if(!store.state.vueOnboarding.allowActions.next) return;

        Vue.prototype.$tours.onboarding.nextStep();
    }

    prev() {
        if(!this.hasOnboarding()) {
            console.log("[prev] This account haven't onboarding");
            return;
        }

        if(!store.state.vueOnboarding.allowActions.previous) return;

        Vue.prototype.$tours.onboarding.previousStep();
    }

    skip() {
        if(!this.hasOnboarding()) {
            console.log("[skip] This account haven't onboarding");
            return;
        }
        
        // Only action with prototype of $tours
        Vue.prototype.$tours.onboarding.skip();
    }

    finish() {
        if(!this.hasOnboarding()) {
            console.log("[finish] This account haven't onboarding");
            return;
        }

        this.setFinish(true);
        setTimeout(() => this.resetOnboarding, 0);
        // After that to finish onboarding tour
        Vue.prototype.$tours.onboarding.finish();
    }

    currentStep() {
        return Vue.prototype.$tours.onboarding.currentStep + 1;
    }

    setSteps(steps = []) {
        if(!this.hasOnboarding()) {
            console.log("[setSteps] This account haven't onboarding");
            return;
        }

        store.dispatch(SET_STEPS, steps);
    }

    setAllowNextStepAction(allow = true) {
        if(!this.hasOnboarding()) {
            console.log("[setAllowNextStepAction] This account haven't onboarding");
            return;
        }

        store.dispatch(SET_ALLOW_ACTIONS_NEXT, allow);
    }

    setAllowPreviousStepAction(allow = true) {
        if(!this.hasOnboarding()) {
            console.log("[setAllowPreviousStepAction] This account haven't onboarding");
            return;
        }

        store.dispatch(SET_ALLOW_ACTIONS_PREVIOUS, allow);
    }

    setFinish(finished = true) {
        if(!this.hasOnboarding()) {
            console.log("[setFinish] This account haven't onboarding");
            return;
        }

        store.dispatch(SET_FINISHED, finished);
    }

    setHasOnboarding(has = true) {
        store.dispatch(HAS_ONBOARDING, has);
    }

    setCompleteAll(status = true) {
        store.dispatch(SET_COMPLETED_ALL, status);
    }
    
    setSkip(status = true) {
        store.dispatch(SET_SKIP, status);
    }
    
    setHolding(status = true) {
        store.dispatch(HOLDING_STEP, status);
    }

    setUserOnboardingPerPage(pageName) {
        store.dispatch(SET_ONBOARDING_PER_PAGE, pageName);
    }   
}

const onboardingService = new OnboardingService();

export default onboardingService;



// WEBPACK FOOTER //
// ./src/core/services/onboardingService.js